export default __webpack_public_path__ + "static/media/verify.a152c8dd.png";